import React from 'react';
import { connect } from 'react-redux';

import Template from './../../templates/InfoaddSelect';
import { commonOperations } from './../../../reducks/common';
import { infoaddSelectOperations } from './../../../reducks/infoaddSelect'; 

const mapStateToProps = state => ({
  currentTheme: state.common.theme,
});
const mapDispatchToProps = {
  doClearStore: commonOperations.storeInit,
  doSetShelterName: infoaddSelectOperations.setShelterNameOperation,
  doSetEntryKubun: infoaddSelectOperations.setEntryKubunOperation,
  doGetEntryKubun: infoaddSelectOperations.getEntryKubun
};

class App extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "入所選択";

    let param = window.location.search.substring(1).split('=');
    let place = decodeURIComponent(param[1]);
    if ( place === "" || place === 'undefined'){
      place = "避難所";
    }
    this.props.doSetShelterName(place);    
    // 遷移元区分を初期化
    this.props.doSetEntryKubun(0);
  }
  componentWillMount() {
    this.props.doClearStore();
    localStorage.clear();
  }

  render() {
    return (
      <Template {...this.props} />
    );
  }
}

const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
export default ContainerApp;
